module.exports = __webpack_public_path__ + "static/media/Nonlinear_Final_Project_on_Fast-Slow_Analysis.2ef4e24b.pdf";